<title>{{ htmlTitle }}</title>
<div class="banner-image r-notice-banner" class="banner" style="background-image: url('{{ banner && banner.image }}');"></div>
<div class="container">
  <div class="mb-30" id="pgcontent" class="websiteSearch">
    <div class="row mt-40 mb-30">
      <div class="col-sm-12">
        <span class="subtitle">Search</span>
        <div class="input-group">
          <input type="text" autofocus class="form-control srchmain" autocomplete="off" [(ngModel)]="searchQuery" placeholder="Search for..." (keyup)="onChangeSearch(searchQuery)" />
        </div>
      </div>
    </div>
  </div>

  <h4>Showing Results</h4>
  <ng-template [ngIf]="pNumberList.length > 0">
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link" (click)="triggerPagination('back')" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li *ngFor="let p of pNumberList" [class.active]="p.start === pSettings.start" class="page-item">
          <a class="page-link" (click)="updateStart(p.start)">{{ p.label }}</a>
        </li>
        <li class="page-item">
          <a class="page-link" (click)="triggerPagination('next')" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </ng-template>

  <div class="mb-3" *ngFor="let result of displayResult">
    <a [href]="result.url">
      <h4 class="searchTitle">{{ result.searchResultTitle }}</h4>
    </a>
    <span class="urlColor">{{ result.url }}</span> <br />
    <span [innerHTML]="result.searchResultLine | searchHighlighter : searchQuery"></span>
  </div>
  <div *ngIf="displayResult && displayResult.length === 0">
    <p>
      <strong>{{ searchNotFound }}</strong>
    </p>
  </div>
</div>